// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuItem_wrapper__VMDH+","iconContainer":"MenuItem_iconContainer__sGxuW"};